<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    {{ viewStateHeaders[viewState] }}
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="onDismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <!------------------------->
  <!-- select payline type -->
  <!------------------------->
  <div *ngIf="viewState == viewStates.SelectType" class="mt-3">
    <!-- regular pay -->
    <div class="border-bottom border-light border-2 d-flex py-2">
      <div class="w-25 align-self-center">
        <input
          type="radio"
          class="small"
          id="regular-opt"
          [value]="paylineTypes.Normal"
          [(ngModel)]="typeSelection" />
        <label class="fw-bold mb-0" for="regular-opt"><span></span>Regular Pay</label>
      </div>
      <div
        class="w-75 small align-self-center cursor-pointer"
        (click)="typeSelection = paylineTypes.Normal">
        Create a new standard pay.
      </div>
    </div>
    <!-- history void -->
    <div class="border-bottom border-light border-2 d-flex py-2">
      <div class="w-25 align-self-center">
        <input
          type="radio"
          class="small"
          id="history-void-opt"
          [value]="paylineTypes.Void"
          [(ngModel)]="typeSelection"
          [disabled]="!historyVoidPayrolls?.length"
          data-testid="addHistoryVoidPaylineOption" />
        <label class="fw-bold mb-0" for="history-void-opt"><span></span>History Void</label>
      </div>
      <div
        class="w-75 small align-self-center cursor-pointer"
        (click)="historyVoidPayrolls?.length && (typeSelection = paylineTypes.Void)"
        [ngClass]="{ disabled: !historyVoidPayrolls?.length }">
        Correct or adjust historical payroll records.
      </div>
    </div>
    <!-- no check temporarily disabled -->
    <!-- <div class="border-bottom border-light border-2 d-flex py-2">
      <div class="w-25 align-self-center">
        <input type="radio" class="small" id="no-check-opt" [value]="paylineTypes.NoCheck"
               [(ngModel)]="typeSelection" data-testid="addNoCheckPaylineOption" />
        <label class="fw-bold mb-0" for="no-check-opt"><span></span>No Check</label>
      </div>
      <div class="w-75 small align-self-center cursor-pointer" (click)="typeSelection = paylineTypes.NoCheck">
        Record payments made to an individual outside of regular payroll for tax and accounting purposes.
      </div>
    </div> -->
    <div class="d-flex mt-5 justify-content-end">
      <button class="btn btn-secondary" (click)="onClose()">Cancel</button>
      <button class="btn btn-primary ms-3" (click)="onContinue()">Confirm & Continue</button>
    </div>
  </div>
  <!------------------------->
  <!-- select history void -->
  <!------------------------->
  <div *ngIf="viewState == viewStates.HistoryVoidSelection" class="mt-2">
    <lib-history-void-selection
      [payrolls]="historyVoidPayrolls"
      [personName]="personName"
      (handleBack)="onVoidSelectionBack()"
      (handleContinue)="onVoidSelectionContinue($event)"></lib-history-void-selection>
  </div>
  <!-------------------------->
  <!-- history void details -->
  <!-------------------------->
  <div *ngIf="viewState == viewStates.HistoryVoidDetails">
    <lib-history-void-details
      [args]="historyVoidDetailArgs"
      [payroll]="selHistoryVoid.Payroll"
      [startData]="startData"
      [earningConfigs]="earningConfigs"
      [deductionConfigs]="deductionConfigs"
      [taxConfigs]="taxConfigs"
      [employeePay]="employeePay"
      (handleBack)="onVoidDetailBack()"
      (handleContinue)="onVoidDetailContinue()"></lib-history-void-details>
  </div>
  <!-------------------------->
  <!---- no check details ---->
  <!-------------------------->
  <div *ngIf="viewState == viewStates.NoCheckDetails">
    <lib-no-check-details
      [args]="noCheckDetailArgs"
      [payroll]="payroll"
      [startData]="startData"
      [earningConfigs]="earningConfigs"
      [deductionConfigs]="deductionConfigs"
      [taxConfigs]="taxConfigs"
      [employeePay]="employeePay"
      (handleBack)="onNoCheckDetailBack()"
      (handleContinue)="onNoCheckDetailContinue($event)"></lib-no-check-details>
  </div>
</div>
